<template>
  <v-card :loading="isLoading" :disabled="isLoading">
    <v-card-title>
      <v-row justify="space-between">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.changePassword') }}</span>
        <v-btn icon @click.stop="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-form v-model="isFormValid" ref="changePasswordForm" autocomplete="off" @submit.prevent="">
      <v-card-text>
        <v-row>
          <v-col cols="12">
              <v-text-field
                v-model="user.oldPassword"
                :rules="[rules.required]"
                :label="$t('label.oldPassword')"
                prepend-inner-icon="mdi-lock"
                :append-icon="showOldPassword ? 'mdi-eye-off': 'mdi-eye'"
                :type="showOldPassword ? 'text' : 'password'" @click:append="showOldPassword = !showOldPassword" name="oldPassword" outlined dense>
              </v-text-field>
          </v-col>
          <v-col cols="12">
              <v-text-field
                v-model="user.newPassword"
                :rules="[rules.required, rules.minCharacters(user.newPassword, 8)]"
                :label="$t('label.newPassword')"
                prepend-inner-icon="mdi-lock"
                :append-icon="showNewPassword ? 'mdi-eye-off': 'mdi-eye'"
                :type="showNewPassword ? 'text' : 'password'" @click:append="showNewPassword = !showNewPassword" name="newPassword" outlined dense>
              </v-text-field>
          </v-col>
          <v-col cols="12">
              <v-text-field
                v-model="user.repeatNewPassword"
                :rules="[rules.required, rules.repeatPassword(user.newPassword, user.repeatNewPassword)]"
                :label="$t('label.repeatNewPassword')"
                prepend-inner-icon="mdi-lock"
                :append-icon="showRepeatNewPassword ? 'mdi-eye-off': 'mdi-eye'"
                :type="showRepeatNewPassword ? 'text' : 'password'" @click:append="showRepeatNewPassword = !showRepeatNewPassword" name="repeatNewPassword" outlined dense>
              </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small depressed @click.stop="cancel" :disabled="isLoading">{{ $t('label.cancel') }}</v-btn>
        <v-btn small depressed @click.stop="isConfirmationChangePasswordDialogOpen = true" color="primary" :loading="isLoading" :disabled="!isFormValid">{{ $t('label.savePassword') }}</v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="isConfirmationChangePasswordDialogOpen" max-width="500" persistent>
      <confirmation-dialog @confirm="confirmationChangePassword">
        <span v-text="$t('message.confirmation.changePassword')"></span>
      </confirmation-dialog>
    </v-dialog>
  </v-card>
</template>

<script>
import { loading, rules, showMessage } from '../../mixins'
import ConfirmationDialog from '../Shared/ConfirmationDialog'

export default {
  name: 'ChangePassword',
  components: { ConfirmationDialog },
  mixins: [loading, rules, showMessage],
  data: () => ({
    isFormValid: null,
    isConfirmationChangePasswordDialogOpen: false,
    showOldPassword: false,
    showNewPassword: false,
    showRepeatNewPassword: false,
    user: {
      oldPassword: '',
      newPassword: '',
      repeatNewPassword: ''
    }
  }),
  methods: {
    confirmationChangePassword (confirm) {
      this.isConfirmationChangePasswordDialogOpen = false
      if (confirm) {
        this.changePassword()
      }
    },
    changePassword () {
      this.changeLoadingStatus(true)

      this.$proxy.post('api/vendors/changepassword', this.user)
        .then((r) => {
          this.showMessage(this.$t('message.success.passwordChanged'))
          this.$emit('saved')
          this.clearForm()
        })
        .catch((e) => {
          if (e.response.status === 401) {
            this.showMessage(this.$t('message.error.incorrectPassword'))
          } else {
            this.showHttpErrorMessage(e)
          }
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    cancel () {
      this.clearForm()
      this.$emit('cancel')
    },
    clearForm () {
      this.user = {
        oldPassword: '',
        newPassword: '',
        repeatNewPassword: ''
      }
      this.showOldPassword = false
      this.showNewPassword = false
      this.showRepeatNewPassword = false
      this.$refs.changePasswordForm.resetValidation()
    }
  }
}
</script>

<style>

</style>
